"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescribeHandsFingerprintsFormToJSON = exports.DescribeHandsFingerprintsFormFromJSONTyped = exports.DescribeHandsFingerprintsFormFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function DescribeHandsFingerprintsFormFromJSON(json) {
    return DescribeHandsFingerprintsFormFromJSONTyped(json, false);
}
exports.DescribeHandsFingerprintsFormFromJSON = DescribeHandsFingerprintsFormFromJSON;
function DescribeHandsFingerprintsFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'left': !runtime_1.exists(json, 'left') ? undefined : _1.HandFingerprintsFromJSON(json['left']),
        'right': !runtime_1.exists(json, 'right') ? undefined : _1.HandFingerprintsFromJSON(json['right']),
        'thumbprints': !runtime_1.exists(json, 'thumbprints') ? undefined : _1.FingerprintsFromJSON(json['thumbprints']),
    };
}
exports.DescribeHandsFingerprintsFormFromJSONTyped = DescribeHandsFingerprintsFormFromJSONTyped;
function DescribeHandsFingerprintsFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'left': _1.HandFingerprintsToJSON(value.left),
        'right': _1.HandFingerprintsToJSON(value.right),
        'thumbprints': _1.FingerprintsToJSON(value.thumbprints),
    };
}
exports.DescribeHandsFingerprintsFormToJSON = DescribeHandsFingerprintsFormToJSON;
//# sourceMappingURL=DescribeHandsFingerprintsForm.js.map